export default {
  state: {
    snack: '',
    isError: false,
    position: 'top',
    isBlocked: false
  },

  getters: {},

  mutations: {
    setSnack(state, snack) {
      state.snack = snack.message
      state.isError = snack.isError
      state.position = snack.position
      state.isBlocked = snack.isBlocked
    }
  },

  actions: {
    setSnack({ commit }, data) {
      commit('setSnack', data)
    }
  }

}
